import React, { useState } from "react";
import "./Gallery.css"; // We'll style with this file

const images = [
  { src: "/imagesevent/event001.jpeg", alt: "Event" },
  { src: "/imagesevent/event002.jpeg", alt: "Event" },
  { src: "/imagesevent/event003.jpeg", alt: "Event" },
  { src: "/imagesevent/event004.jpeg", alt: "Event" },
  { src: "/imagesevent/event005.jpeg", alt: "Event" },
  { src: "/imagesevent/event006.jpeg", alt: "Event" },
  { src: "/imagesevent/event007.jpeg", alt: "Event" },
  { src: "/imagesevent/event008.jpeg", alt: "Event" },
  { src: "/imagesevent/event009.jpeg", alt: "Event" },
  { src: "/imagesevent/event010.jpeg", alt: "Event" },
 
  // Add more images gallery01
];

function Event01() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            onClick={() => setSelectedImg(img.src)}
            className="gallery-image"
          />
        ))}
      </div>

      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </>
  );
}

export default Event01;
